import * as C from '@components';
import {Color, Margin} from '@components';
import * as Api from '@api';
import css from './announcement-section.module.scss';
import * as P from '@parts';

export const AnnouncementThreeProductSectionKeys = [
    "announcement.headline",
    "announcement.1.headline",
    "announcement.1.body",
    "announcement.2.1.headline",
    "announcement.2.1.body",
    "announcement.3.headline",
    "announcement.3.body",
    "announcement.4.headline",
    "announcement.4.body",
    "announcement.5.headline",
    "announcement.5.body",
] as const;

const imageDirectory = '/images/announcement/'

export type AnnouncementThreeProductSectionProps = {
    pageContent: Api.Content<typeof AnnouncementThreeProductSectionKeys[number]>;
};

const SeedlingAnnouncementSection = ({ pageContent }: AnnouncementThreeProductSectionProps) => (
        <C.ImageCardSection
            imageDirectory={imageDirectory}
            headlineLayout={{ all: { margins: { bottom: Margin.D20 } }, ipad: { margins: { bottom: Margin.D24 } } }}
            keyPrefix="announcement"
            pageContent={pageContent}
            containerProps={{ horizontalGap: 24, verticalGap: 24, justifyCenter: true }}
            cards={[
                ...(Api.SnaptixHidden ? [] : [{
                    node: <P.SnaptixNewReleaseCard />
                }]),
                {
                    key: "4",
                    stdProps: {
                        className: css.card,
                        link: '/products/all-in-ones/active-axil-mini-pro',
                        textColor: Color.BlackDomina,
                        headingTypography: C.Typography.H5,
                        width: C.Width.W372,
                        bodyMaxWidth: C.Width.W288,
                        imagePosition: C.CardImagePosition.Bottom,
                        mobileImageAlignment: C.HorizontalAlignment.Right,
                        imageWidth: 380,
                        imageHeight: 200,
                        indentBefore: 10,
                        mobileImageProps: {
                            mobileWidth: 380,
                            mobileHeight: 200
                        },
                        textLeft: false
                    }
                },
                {
                    key: "2.1",
                    stdProps: {
                        className: css.card,
                        link: '/products/batteries/active-sprout',
                        textColor: Color.BlackDomina,
                        headingTypography: C.Typography.H5,
                        width: C.Width.W372,
                        bodyMaxWidth: C.Width.W288,
                        imagePosition: C.CardImagePosition.Bottom,
                        imageAlignment: C.HorizontalAlignment.Right,
                        imageWidth: 380,
                        imageHeight: 200,
                        indentBefore: 10,
                        mobileImageProps: {
                            mobileWidth: 380,
                            mobileHeight: 200
                        },
                        textLeft: false
                    }
                },
            ]}
        />
);

export default SeedlingAnnouncementSection;
